var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "mon-svg",
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80002 12.6001C6.80002 12.8774 6.94359 13.1349 7.17944 13.2806C7.41529 13.4264 7.70981 13.4396 7.9578 13.3156L11.1578 11.7156C11.4288 11.5801 11.6 11.3031 11.6 11.0001V6.38895C11.6 6.11169 11.4565 5.8542 11.2206 5.70843C10.9848 5.56267 10.6902 5.54942 10.4423 5.67341L7.24225 7.27341C6.97123 7.40892 6.80002 7.68594 6.80002 7.98895V12.6001Z",
    fill: "#6B7280"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1689 4.02121C10.44 3.8857 10.6112 3.60869 10.6112 3.30567C10.6112 3.00265 10.44 2.72564 10.1689 2.59013L6.3578 0.684556C6.13257 0.571945 5.86748 0.571945 5.64225 0.684556L1.83111 2.59013C1.56008 2.72564 1.38888 3.00265 1.38888 3.30567C1.38888 3.60869 1.56008 3.8857 1.83111 4.02121L5.64225 5.92678C5.86748 6.0394 6.13257 6.0394 6.3578 5.92678L10.1689 4.02121Z",
    fill: "#6B7280"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5578 5.67341C1.3098 5.54942 1.01529 5.56267 0.77944 5.70843C0.543586 5.8542 0.400024 6.11169 0.400024 6.38895V11.0001C0.400024 11.3031 0.571226 11.5801 0.842254 11.7156L4.04225 13.3156C4.29024 13.4396 4.58476 13.4264 4.82061 13.2806C5.05646 13.1349 5.20002 12.8774 5.20002 12.6001V7.98895C5.20002 7.68594 5.02882 7.40892 4.7578 7.27341L1.5578 5.67341Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCube);
export default __webpack_public_path__ + "static/media/cube.b75a7e58f567523ccd95c6258fb87577.svg";
export { ForwardRef as ReactComponent };